import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type{ ICreateTransactionData, ICreateTransactionResponse } from '@/interfaces';

export const useRequestCreateTransaction = () => {
	const { invalidate } = useInvalidateQueries();
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.transactions, 'create'],
		mutationFn: (data: ICreateTransactionData) =>
			apiClient.post<ICreateTransactionResponse>(routes.api.transactions, data).then(handleApiResponse),
		onSuccess: () => Promise.all([invalidate(routes.api.transactions), invalidate(routes.api.accountingSummary)])
	});

	const createTransaction = (data: ICreateTransactionData) => mutateAsync(data);

	return {
		isLoading: isPending,
		createTransaction,
		error
	};
};
